import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import SocialLinks from '~/components/SocialLinks';
import SiteSearch from '~/components/SiteSearch';

import { Hiddenh3 } from '~/styles/helpers';

const BottomWrapper = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: ${({ theme }) => theme.colors.text.blue};
`;

const SocialLinksWrapper = styled.div`
    margin: 30px 0 15px;
    padding: 0 30px;
`;

const BottomMobileFooter = ({ socialLinks = [] }) => (
    <BottomWrapper>
        {socialLinks?.length ? (
            <SocialLinksWrapper>
                <Hiddenh3 id="socialMediaLabel">Social Media</Hiddenh3>
                <SocialLinks
                    socialAccounts={socialLinks}
                    color="white"
                    size={27}
                    ariaLabelledBy="socialMediaLabel"
                    role="list"
                />
            </SocialLinksWrapper>
        ) : null}
        <SiteSearch isMobile useSearchDialog={false} />
    </BottomWrapper>
);

BottomMobileFooter.propTypes = {
    socialLinks: PropTypes.arrayOf(PropTypes.shape({}))
};

export default BottomMobileFooter;
